import "./Technology.css";

function Technology({ text }) {
  return <div className="technology">{text}</div>;
}

export default Technology;
